'use strict'

import Vue from 'vue'
import Vuex from 'vuex'

import patient from 'StoreModules/PatientModule'
import visits from 'StoreModules/VisitsModule'
import calendar from 'StoreModules/CalendarModule'
import PhysiotherapistModule from 'StoreModules/PhysiotherapistModule'
import EventModule from 'StoreModules/EventModule'
import VisitModule from 'StoreModules/VisitModule'
import PatientModule from 'StoreModules/PatientModule2'

import PageLoadingModule from 'StoreModules/PageLoadingModule'
import AlertModule from 'StoreModules/AlertModule'
import PaginationModule from 'StoreModules/PaginationModule'

Vue.use(Vuex)

let store = new Vuex.Store({
    modules: {
        PhysiotherapistModule,
        EventModule,
        VisitModule,
        patient,
        visits,
        calendar,
        PatientModule,

        PageLoadingModule,
        AlertModule,
        PaginationModule,
    }
})

export default store